export const products = [
  {
    id: 1,
    name: "آيفون 15 برو ماكس 256 جيجابايت",
    price: "4,999",
    originalPrice: "5,499",
    discount: 9,
    rating: 4.8,
    reviewCount: 1250,
    image: "https://images.unsplash.com/photo-1592750475338-74b7b21085ab?w=300&h=300&fit=crop",
    badge: "الأكثر مبيعاً",
    category: "electronics",
    brand: "Apple",
    keywords: ["iPhone", "ايفون", "آيفون", "أبل", "Apple"],
    description: "آيفون 15 برو ماكس بسعة 256 جيجابايت، أحدث إصدار من أبل مع كاميرا متطورة وأداء فائق"
  },
  {
    id: 2,
    name: "سامسونج جالاكسي S24 ألترا",
    price: "3,799",
    originalPrice: "4,199",
    discount: 10,
    rating: 4.7,
    reviewCount: 890,
    image: "https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=300&h=300&fit=crop",
    badge: "جديد",
    category: "electronics",
    brand: "Samsung",
    keywords: ["Samsung", "Galaxy", "سامسونج", "جالاكسي"],
    description: "سامسونج جالاكسي S24 ألترا مع قلم S Pen وكاميرا 200 ميجابكسل"
  },
  {
    id: 3,
    name: "لابتوب ماك بوك اير M2",
    price: "4,299",
    originalPrice: null,
    discount: null,
    rating: 4.9,
    reviewCount: 567,
    image: "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=300&h=300&fit=crop",
    badge: null,
    category: "electronics",
    brand: "Apple",
    keywords: ["MacBook", "ماك بوك", "أبل", "Apple", "لابتوب"],
    description: "ماك بوك اير مع معالج M2 الجديد، خفيف الوزن وأداء استثنائي"
  },
  {
    id: 4,
    name: "سماعات ايربودز برو الجيل الثاني",
    price: "899",
    originalPrice: "999",
    discount: 10,
    rating: 4.6,
    reviewCount: 2340,
    image: "https://images.unsplash.com/photo-1606220945770-b5b6c2c55bf1?w=300&h=300&fit=crop",
    badge: "خصم محدود",
    category: "electronics",
    brand: "Apple",
    keywords: ["AirPods", "ايربودز", "أبل", "Apple", "سماعات"],
    description: "سماعات ايربودز برو مع إلغاء الضوضاء النشط وجودة صوت فائقة"
  },
  {
    id: 5,
    name: "ساعة أبل الذكية سيريز 9",
    price: "1,599",
    originalPrice: "1,799",
    discount: 11,
    rating: 4.5,
    reviewCount: 1890,
    image: "https://images.unsplash.com/photo-1434493789847-2f02dc6ca35d?w=300&h=300&fit=crop",
    badge: null,
    category: "electronics",
    brand: "Apple",
    keywords: ["Apple Watch", "ساعة أبل", "أبل", "Apple", "ساعة ذكية"],
    description: "ساعة أبل الذكية مع مراقبة الصحة وتطبيقات متنوعة"
  },
  {
    id: 6,
    name: "تابلت آيباد اير الجيل الخامس",
    price: "2,299",
    originalPrice: null,
    discount: null,
    rating: 4.7,
    reviewCount: 756,
    image: "https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?w=300&h=300&fit=crop",
    badge: null,
    category: "electronics",
    brand: "Apple",
    keywords: ["iPad", "آيباد", "أبل", "Apple", "تابلت"],
    description: "آيباد اير مع شاشة Liquid Retina ومعالج M1 القوي"
  },

  // Fashion
  {
    id: 7,
    name: "قميص رجالي قطني أزرق",
    price: "129",
    originalPrice: "179",
    discount: 28,
    rating: 4.3,
    reviewCount: 234,
    image: "https://images.unsplash.com/photo-1602810318383-e386cc2a3ccf?w=300&h=300&fit=crop",
    badge: null,
    category: "fashion",
    brand: null,
    keywords: ["shirt", "قميص"],
    description: "قميص رجالي أنيق من القطن الخالص، مناسب للمناسبات الرسمية"
  },
  {
    id: 8,
    name: "فستان نسائي أنيق",
    price: "299",
    originalPrice: "399",
    discount: 25,
    rating: 4.6,
    reviewCount: 567,
    image: "https://images.unsplash.com/photo-1595777457583-95e059d581b8?w=300&h=300&fit=crop",
    badge: "عرض خاص",
    category: "fashion",
    brand: null,
    keywords: ["dress", "فستان"],
    description: "فستان نسائي أنيق مناسب للمناسبات الخاصة"
  },
  {
    id: 9,
    name: "حذاء رياضي نايك",
    price: "449",
    originalPrice: "549",
    discount: 18,
    rating: 4.8,
    reviewCount: 1234,
    image: "https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=300&h=300&fit=crop",
    badge: "الأكثر مبيعاً",
    category: "fashion",
    brand: "Nike",
    keywords: ["Nike", "نايك", "حذاء", "shoes"],
    description: "حذاء رياضي مريح من نايك، مثالي للجري والأنشطة الرياضية"
  },

  // Home & Kitchen
  {
    id: 10,
    name: "قلاية هوائية فيليبس",
    price: "599",
    originalPrice: "799",
    discount: 25,
    rating: 4.7,
    reviewCount: 890,
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=300&h=300&fit=crop",
    badge: "خصم كبير",
    category: "home",
    brand: "Philips",
    keywords: ["Philips", "فيليبس", "قلاية هوائية", "air fryer"],
    description: "قلاية هوائية صحية بدون زيت، سعة 4 لتر"
  },
  {
    id: 11,
    name: "مجموعة أواني طبخ",
    price: "349",
    originalPrice: null,
    discount: null,
    rating: 4.4,
    reviewCount: 456,
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=300&h=300&fit=crop",
    badge: null,
    category: "home",
    brand: null,
    keywords: ["أواني", "cookware"],
    description: "مجموعة أواني طبخ من الستانلس ستيل عالية الجودة"
  },
  {
    id: 12,
    name: "مكنسة كهربائية ذكية",
    price: "899",
    originalPrice: "1,199",
    discount: 25,
    rating: 4.5,
    reviewCount: 678,
    image: "https://tse3.mm.bing.net/th/id/OIP.cBwD9RjC1N3GNCxs9jdZUAHaHa?w=640&h=640&rs=1&pid=ImgDetMain&o=7&rm=3",
    badge: "تقنية ذكية",
    category: "home",
    brand: null,
    keywords: ["مكنسة", "vacuum", "robot vacuum"],
    description: "مكنسة كهربائية ذكية مع تحكم عبر التطبيق"
  },

  // Beauty & Personal Care
  {
    id: 13,
    name: "عطر شانيل الأصلي",
    price: "599",
    originalPrice: "699",
    discount: 14,
    rating: 4.9,
    reviewCount: 345,
    image: "https://images.unsplash.com/photo-1541643600914-78b084683601?w=300&h=300&fit=crop",
    badge: "أصلي 100%",
    category: "beauty",
    brand: "Chanel",
    keywords: ["Chanel", "شانيل", "عطر", "perfume"],
    description: "عطر شانيل الأصلي برائحة فاخرة تدوم طويلاً"
  },
  {
    id: 14,
    name: "كريم مرطب للوجه",
    price: "89",
    originalPrice: "119",
    discount: 25,
    rating: 4.6,
    reviewCount: 789,
    image: "https://m7et.com/wp-content/uploads/2020/10/fc72e3e1b6dbb9435440605849d91a14.jpg",
    badge: null,
    category: "beauty",
    brand: null,
    keywords: ["كريم", "moisturizer"],
    description: "كريم مرطب طبيعي للوجه مناسب لجميع أنواع البشرة"
  },

  // Sports & Outdoors
  {
    id: 15,
    name: "دراجة هوائية جبلية",
    price: "1,299",
    originalPrice: "1,599",
    discount: 19,
    rating: 4.7,
    reviewCount: 234,
    image: "https://images.unsplash.com/photo-1571068316344-75bc76f77890?w=300&h=300&fit=crop",
    badge: "عرض محدود",
    category: "sports",
    brand: null,
    keywords: ["دراجة", "bicycle", "bike"],
    description: "دراجة هوائية جبلية عالية الجودة مع 21 سرعة"
  },
  {
    id: 16,
    name: "حقيبة رياضية",
    price: "149",
    originalPrice: "199",
    discount: 25,
    rating: 4.4,
    reviewCount: 456,
    image: "https://images.unsplash.com/photo-1553062407-98eeb64c6a62?w=300&h=300&fit=crop",
    badge: null,
    category: "sports",
    brand: null,
    keywords: ["حقيبة", "bag"],
    description: "حقيبة رياضية واسعة ومقاومة للماء"
  },
  // Mens Fashion
{
  id: 17,
  name: "تيشيرت رجالي قطني",
  price: "149",
  rating: 4.5,
  reviewCount: 250,
  image: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=300",
  category: "mens-fashion",
  brand: null,
  keywords: ["تيشيرت", "t-shirt"],
  description: "تيشيرت رجالي مريح"
},

// Women Fashion
{
  id: 18,
  name: "فستان حريمي أنيق",
  price: "299",
  rating: 4.7,
  reviewCount: 410,
  image: "https://images.unsplash.com/photo-1496747611176-843222e1e57c?w=300",
  category: "womens-fashion",
  brand: null,
  keywords: ["فستان", "dress"],
  description: "فستان مناسب للمناسبات"
},

// Kids
{
  id: 19,
  name: "طقم أطفال",
  price: "179",
  rating: 4.4,
  reviewCount: 120,
  image: "https://images.unsplash.com/photo-1519238263530-99bdd11df2ea?w=300",
  category: "kids-fashion",
  brand: null,
  keywords: ["أطفال", "kids"],
  description: "ملابس أطفال عالية الجودة"
},

// Home Furniture
{
  id: 20,
  name: "كنبة مودرن",
  price: "1299",
  rating: 4.8,
  reviewCount: 95,
  image: "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=300",
  category: "home-furniture",
  brand: null,
  keywords: ["كنبة", "sofa", "couch"],
  description: "كنبة عصرية"
},

// Home Appliances
{
  id: 21,
  name: "غسالة أوتوماتيك",
  price: "2199",
  rating: 4.6,
  reviewCount: 180,
  image: "https://images.unsplash.com/photo-1626806787461-102c1bfaaea1?w=300",
  category: "home-appliances",
  brand: null,
  keywords: ["غسالة", "washing machine"],
  description: "غسالة موفرة للطاقة"
},

// Skin Care
{
  id: 22,
  name: "سيروم فيتامين C",
  price: "99",
  rating: 4.7,
  reviewCount: 350,
  image: "https://images.unsplash.com/photo-1620916566398-39f1143ab7be?w=300",
  category: "skin-care",
  brand: null,
  keywords: ["سيروم", "serum", "Vitamin C"],
  description: "سيروم للعناية بالبشرة"
},

// Baby Products
{
  id: 23,
  name: "عربة أطفال",
  price: "799",
  rating: 4.8,
  reviewCount: 140,
  image: "https://images.unsplash.com/photo-1515488764276-beab7607c1e6?w=300",
  category: "baby-products",
  brand: null,
  keywords: ["عربة أطفال", "stroller"],
  description: "عربة أطفال عملية"
},

// Toys
{
  id: 24,
  name: "سيارة ألعاب",
  price: "89",
  rating: 4.5,
  reviewCount: 230,
  image: "https://images.unsplash.com/photo-1566576912321-d58ddd7a6088?w=300",
  category: "toys",
  brand: null,
  keywords: ["سيارة ألعاب", "toy car"],
  description: "لعبة أطفال ممتعة"
},

// Grocery
{
  id: 25,
  name: "سلة مواد غذائية",
  price: "199",
  rating: 4.6,
  reviewCount: 320,
  image: "https://images.unsplash.com/photo-1542838132-92c53300491e?w=300",
  category: "grocery",
  brand: null,
  keywords: ["بقالة", "grocery"],
  description: "منتجات غذائية متنوعة"
}
]

// Categories data
export const categories = [
  {
    id: 1,
    name: "الإلكترونيات",
    slug: "electronics",
    image: "https://images.unsplash.com/photo-1498049794561-7780e7231661?w=300&h=200&fit=crop",
    itemCount: "1000+ منتج"
  },
  {
    id: 2,
    name: "أزياء رجالي",
    slug: "mens-fashion",
    image: "https://images.unsplash.com/photo-1617127365659-c47fa864d8bc?w=300&h=200&fit=crop",
    itemCount: "700+ منتج"
  },
  {
    id: 3,
    name: "أزياء حريمي",
    slug: "womens-fashion",
    image: "https://images.unsplash.com/photo-1483985988355-763728e1935b?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8d29tYW4lMjBjbG90aGVzfGVufDB8fDB8fHww",
    itemCount: "1200+ منتج"
  },
  {
    id: 4,
    name: "أزياء الأطفال",
    slug: "kids-fashion",
    image: "https://images.unsplash.com/photo-1503919545889-aef636e10ad4?w=300&h=200&fit=crop",
    itemCount: "500+ منتج"
  },
  {
    id: 5,
    name: "المنزل والأثاث",
    slug: "home-furniture",
    image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=300&h=200&fit=crop",
    itemCount: "800+ منتج"
  },
  {
    id: 6,
    name: "الأجهزة المنزلية",
    slug: "home-appliances",
    image: "https://images.unsplash.com/photo-1574269909862-7e1d70bb8078?w=300&h=200&fit=crop",
    itemCount: "650+ منتج"
  },
  {
    id: 7,
    name: "الجمال والعطور",
    slug: "beauty-perfumes",
    image: "https://images.unsplash.com/photo-1596462502278-27bfdc403348?w=300&h=200&fit=crop",
    itemCount: "600+ منتج"
  },
  {
    id: 8,
    name: "العناية بالبشرة",
    slug: "skin-care",
    image: "https://images.unsplash.com/photo-1571781926291-c477ebfd024b?w=300&h=200&fit=crop",
    itemCount: "450+ منتج"
  },
  {
    id: 9,
    name: "منتجات الأطفال",
    slug: "baby-products",
    image: "https://images.unsplash.com/photo-1516627145497-ae6968895b74?w=300&h=200&fit=crop",
    itemCount: "350+ منتج"
  },
  {
    id: 10,
    name: "الألعاب",
    slug: "toys",
    image: "https://images.unsplash.com/photo-1596461404969-9ae70f2830c1?w=300&h=200&fit=crop",
    itemCount: "300+ منتج"
  },
  {
    id: 12,
    name: "مستلزمات رياضية",
    slug: "sports",
    image: "https://images.unsplash.com/photo-1517649763962-0c623066013b?w=300&h=200&fit=crop",
    itemCount: "400+ منتج"
  },
  {
    id: 13,
    name: "السوبر ماركت",
    slug: "grocery",
    image: "https://images.unsplash.com/photo-1542838132-92c53300491e?w=300&h=200&fit=crop",
    itemCount: "900+ منتج"
  }
]

// Helper functions
export const getProductsByCategory = (category) => {
  return products.filter(product => product.category === category)
}

export const getFeaturedProducts = () => {
  return products.filter(product => product.badge)
}

export const getBestSellingProducts = () => {
  return products.sort((a, b) => b.reviewCount - a.reviewCount).slice(0, 8)
}

export const getDiscountedProducts = () => {
  return products.filter(product => product.discount).slice(0, 8)
}
